export const HomePageAPI = "/bootstrap?menu_with_images=single";

export const ProductSearchAPI = "/productSearch";

export const MegaMenuAPI = "/lightbootstrap?menu_with_images=single";

export const ProductDetailAPI = "/productdetail";

export const CartAPI = "/cart";

export const SetAddressCheckoutAPI = "/setaddresscheckout";

export const FeaturedProductAPI = "/featuredproducts";

export const CategoryAPI = "/categoryProducts";

export const LoginAPI = "/login";

export const RegisterAPI = "/register";

export const LogoutAPI = "/logout";

export const AccountInfoAPI = "/accountInfo";

export const UpdateCustomerAPI = "/accountedit";

export const OrderHistoryAPI = "/orderhistory";

export const AllAddressesAPI = "/alladdresses";

export const AddressDetailsAPI = "/address";

export const CarryShopsAPI = "/carry-maps";

export const CarriersAPI = "/carriers";

export const PaymentsAPI = "/paymentoptions";

export const PopularSearchesAPI = "/popular-searches";

export const OrderReturnAPI = "/orderreturn";

export const CustomReturnFormAPI = "/carrycustomreturn";

export const ShopAvailabilityAPI = "/shopavailability";

export const FeaturedProductsAPI = "/featuredproducts";

export const GetResponseAPI = "/getresponse";

export const ResetPasswordAPI = "/resetpasswordbyemail";

export const SetCarrierCheckoutAPI = "/setcarriercheckout";

export const CreateOrderAPI = "/customercreateorder";

export const PickupPointsAPI = "/pickuppoints";

export const ContactFormAPI = "/contactform";
